import React from 'react'

const HomeChefMenuMobile = () => {
    return (
        <div>HomeChefMenuMobile</div>
    )
}

export default HomeChefMenuMobile